import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { AnimatedWidthButton } from "app/features/product/components/animatedWidthButton/AnimatedWidthButton";
import { FilterSortPopover } from "app/features/product/components/filterSortPopover/FilterSortPopover";
import { useState } from "react";
import PropTypes from "prop-types";
import { SortPopoverForm } from "./SortPopoverForm";
import { Formik } from "formik";
import { useSortContext } from "../../contexts/SortProvider";
import { FormattedMessage, useIntl } from "react-intl";
import { getSortLabelKey } from "../../utils/getSortLabelKey";
import { ArrowUpDownIcon } from "../../icons/ArrowUpDownIcon";
import { getSortLabel } from "../../utils/getSortLabel";

export const SortPopover = ({
	facetId = "sortBy",
	onOpen,
	onClose,
	onToggle,
	onSubmit,
	boundaryRef,
}) => {
	const { sortBy, setSortBy, options } = useSortContext();
	const { formatMessage } = useIntl();
	const [isOpen, setIsOpen] = useState(false);

	const sortLabel =
		getSortLabel(sortBy, options) || formatMessage({ id: getSortLabelKey(sortBy, options) });

	const handleSubmit = values => {
		if (onSubmit) {
			onSubmit(values);
		}

		setSortBy(values?.sortBy);
		setIsOpen(false);
	};

	return (
		<FilterSortPopover.Root
			id={facetId}
			open={isOpen}
			onOpenChange={setIsOpen}
			onOpen={onOpen}
			onClose={onClose}
			onToggle={onToggle}
			boundaryRef={boundaryRef}
		>
			<FilterSortPopover.Trigger>
				<AnimatedWidthButton isActive={isOpen} isOpen={isOpen} data-testid="sort-by-button">
					<ArrowUpDownIcon />
					<Typography component="span" variant={TYPOGRAPHY_VARIANTS.SMALL}>
						<FormattedMessage id="sort.sort.by" /> :{" "}
						<Typography component="span" isBold variant={TYPOGRAPHY_VARIANTS.SMALL}>
							{sortLabel}
						</Typography>
					</Typography>
				</AnimatedWidthButton>
			</FilterSortPopover.Trigger>

			<FilterSortPopover.Content>
				<Formik initialValues={{ sortBy }} onSubmit={handleSubmit} enableReinitialize>
					<SortPopoverForm />
				</Formik>
			</FilterSortPopover.Content>
		</FilterSortPopover.Root>
	);
};

SortPopover.propTypes = {
	facetId: PropTypes.string.isRequired,
	onOpen: PropTypes.func,
	onClose: PropTypes.func,
	onToggle: PropTypes.func,
	onSubmit: PropTypes.func,
	boundaryRef: PropTypes.shape({
		current: PropTypes.object,
	}),
};
